/**
 * @file Stats
 */

import { CountUp } from 'countup.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const vStats = () => {
	gsap.registerPlugin( ScrollTrigger );

	class statCounter {
		constructor( s ) {
			this.stat        = s;
			this.counterUp   = null;
			this.counterDown = null;
			this.wayDown     = null;
			this.wayUp       = null;
			this.textNum     = this.stat.innerText.trim();
			this.endVal      = parseFloat( this.textNum );
			this.startVal    = Math.max( 0, this.endVal - 10 );
			this.decimal     = this.textNum.indexOf( '.' );
		}

		init() {
			this.counterUp = new CountUp( this.stat, this.endVal, {
				startVal:      this.startVal,
				decimalPlaces: this.decimal !== -1 ? this.textNum.length - this.decimal - 1 : 0,
			} );

			this.counterDown = new CountUp(this.stat, this.startVal, {
				startVal: this.endVal,
				decimalPlaces: this.decimal !== -1 ? this.textNum.length - this.decimal - 1 : 0
			});

			ScrollTrigger.create({
				trigger: this.stat,
				start: 'top bottom-=20',
				onEnter: () => {
					this.counterUp.reset();
					this.counterUp.start();
				},
			});
		}
	}

	const stats = document.querySelectorAll( '.a-cs-stats__number' );

	if (!stats.length) {
		return;
	}

	[ ...stats ].forEach((s) => {
		const sC = new statCounter(s);
		sC.init();
	});
};

export default vStats;
